import { render, staticRenderFns } from "./ElectricFence.vue?vue&type=template&id=0b39934e&"
import script from "./ElectricFence.vue?vue&type=script&lang=js&"
export * from "./ElectricFence.vue?vue&type=script&lang=js&"
import style0 from "./ElectricFence.vue?vue&type=style&index=0&id=0b39934e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports